var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"img-container",staticStyle:{"{ height":"imageHeight + 'px'","width":"imageWidth + 'px' }"}},[_c('img',{ref:"image",attrs:{"src":_vm.src,"crossorigin":""}})]),_vm._v(" "),_c('img',{staticClass:"img-preview",attrs:{"src":_vm.destination}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a07de72","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/organisms/ImageCropper.vue
// module id = 1693
// module chunks = 5